/** @jsx jsx */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react'
import { css, jsx } from '@emotion/core'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import logo from '../../assets/logo.png'
import logoMobile from '../../assets/logo-mobile.png'

const Container = styled.div`
  padding-left: 20px;
  height: 90px;
  display: flex;
  align-items: center;

  img {
    max-width: 250px;
  }

  @media (max-width: 700px) {
    justify-content: flex-start;

    img {
      max-width: 39px;
    }
  }
`
const styles = {}
styles.clickButton = css`
  border: 0;
  background: transparent;
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  cursor: pointer;

  @media (min-width: 701px) {
    margin-left: 40px;
  }
`

function NavBar(props) {
  const [logoSrc, setLogoSrc] = useState(window.screen.width > 700 ? logo : logoMobile)
  const [windowWidth, setWindowWidth] = useState(window.screen.width)

  const resizeWindow = () => {
    const logoResize = window.innerWidth > 700 ? logo : logoMobile
    setLogoSrc(logoResize)
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    resizeWindow()
    window.addEventListener('resize', resizeWindow)
    return () => window.removeEventListener('resize', resizeWindow)
  }, [])

  return (
    <Container>
      <a
        href="http://metrica-sports.com"
        css={styles.clickButton}
        style={{ width: `${windowWidth > 700 ? 250 : 39}px` }}
      >
        <img src={logoSrc} alt="Metrica Sports" style={{ width: '100%' }} />
      </a>
    </Container>
  )
}

NavBar.propTypes = {
  referral: PropTypes.string
}

NavBar.defaultProps = {
  referral: undefined
}

export default NavBar
